import { useState, useEffect } from 'react';

import { WidgetTheme } from 'widget/entities/config';
import { Theme } from 'widget/entities/themes';

const DARK_MQ = '(prefers-color-scheme: dark)';

export const useResolvedTheme = (theme?: WidgetTheme): Theme => {
  const [prefersDark, setPrefersDark] = useState(
    () => typeof window !== 'undefined' && window.matchMedia(DARK_MQ).matches
  );

  useEffect(() => {
    if (theme !== WidgetTheme.system) {
      return;
    }

    const mq = window.matchMedia(DARK_MQ);
    const handler = (e: MediaQueryListEvent) => setPrefersDark(e.matches);

    mq.addEventListener('change', handler);

    return () => mq.removeEventListener('change', handler);
  }, [theme]);

  if (!theme || theme === WidgetTheme.light) {
    return Theme.light;
  }

  if (theme === WidgetTheme.dark) {
    return Theme.dark;
  }

  return prefersDark ? Theme.dark : Theme.light;
};
